{
  "app.title": "ColorGlo Kalender",
  "app.scaffold.heading": "Grundstommen står",
  "app.scaffold.body": "Personalens kalender, franchiseadmin och nätverksvyn byggs i den här appen (P7–P10).",
  "health.label": "API",
  "health.checking": "Kontrollerar …",
  "health.ok": "Tillgängligt",
  "health.unreachable": "Kan inte nås",
  "nav.calendar": "Kalender",
  "nav.bookings": "Bokningar",
  "nav.customers": "Kunder",
  "nav.reports": "Rapporter",
  "nav.settings": "Inställningar",
  "nav.overview": "Översikt",
  "nav.toggle_menu": "Visa eller dölj menyn",
  "nav.more": "Fler",
  "nav.breadcrumb": "Var du är",
  "nav.account": "Konto",
  "nav.impersonating": "Du arbetar som {email}. Allt du gör loggas på båda konton.",
  "nav.close": "Stäng",
  "nav.language": "Språk",
  "language.sv": "Svenska",
  "language.no": "Norsk",
  "language.en": "English",
  "nav.theme": "Utseende",
  "theme.light": "Ljust",
  "theme.dark": "Mörkt",
  "form.required": "Obligatoriskt",
  "language.da": "Dansk",
  "language.fi": "Suomi"
}
